/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type ArticleListItem_article$ref = any;
export type ConfigurableBlockType = "embed" | "listNews" | "live" | "news" | "video" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type ArticleList_viewer$ref: FragmentReference;
export type ArticleList_viewer = {|
  +configurableBlock: ?{|
    +id: string,
    +type: ConfigurableBlockType,
    +slug: ?string,
    +config: ?any,
    +active: ?boolean,
  |},
  +articles: ?{|
    +totalCount: ?number,
    +articles: ?$ReadOnlyArray<?{|
      +$fragmentRefs: ArticleListItem_article$ref
    |}>,
  |},
  +$refType: ArticleList_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "ArticleList_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "page",
      "type": "Int!",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "search",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "blockSlug",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "section",
      "type": "ID!",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "states",
      "type": "[ArticleStateType]",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "configurableBlock",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "slug",
          "variableName": "blockSlug",
          "type": "String"
        }
      ],
      "concreteType": "ConfigurableBlock",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "type",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "slug",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "config",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "active",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": "articles",
      "name": "articlesPaginate",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "page",
          "variableName": "page",
          "type": "Int"
        },
        {
          "kind": "Literal",
          "name": "pageSize",
          "value": 12,
          "type": "Int"
        },
        {
          "kind": "Variable",
          "name": "plainSearch",
          "variableName": "search",
          "type": "String"
        },
        {
          "kind": "Variable",
          "name": "section",
          "variableName": "section",
          "type": "ID"
        },
        {
          "kind": "Variable",
          "name": "states",
          "variableName": "states",
          "type": "[ArticleStateType]"
        }
      ],
      "concreteType": "ArticlesPagination",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "totalCount",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "articles",
          "storageKey": null,
          "args": null,
          "concreteType": "Article",
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "ArticleListItem_article",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '131939770eb7ef1363c1e388dc6811f8';
module.exports = node;



// WEBPACK FOOTER //
// src/components/articles/__generated__/ArticleList_viewer.graphql.js